import { render, staticRenderFns } from "./notice-user-view.vue?vue&type=template&id=f98ce576&"
import script from "./notice-user-view.vue?vue&type=script&lang=js&"
export * from "./notice-user-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports